<template>
  <v-dialog
    v-bind="$attrs"
    v-model="dialog"
    scrollable
    :persistent="modal"
    :overlay="false"
    transition="dialog-transition"
  >
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark v-show="!hideCloseButton" @click="fechar">
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>

      <slot name="busca"></slot>

      <v-card-text :style="styleCardText">
        <slot></slot>
      </v-card-text>

      <v-divider v-if="$slots['botoes'] && !hideDivider"></v-divider>

      <v-card-actions v-if="$slots['botoes']" class="pa-4">
        <slot name="botoes_esquerda"></slot>
        <v-spacer></v-spacer>
        <slot name="botoes">
          <v-btn color="primary" @click="fechar()">OK</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "as-dialogo",
  props: {
    title: {
      type: String,
      default: "",
    },

    modal: {
      type: Boolean,
      default: true,
    },

    hideCloseButton: {
      type: Boolean,
      default: false,
    },

    altura: {
      type: String,
      default: "",
    },

    semPadding: {
      type: Boolean,
      default: false,
    },

    noScroll: {
      type: Boolean,
      default: false,
    },

    hideDivider: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    abrir() {
      this.dialog = true;
      this.$emit("onAbrir");
    },

    fechar() {
      this.dialog = false;
      this.$emit("onFechar");
    },
  },
  computed: {
    styleCardText() {
      return {
        height: this.altura ? this.altura : "",
        padding: this.semPadding ? "0px" : "16px",
        overflow: this.noScroll ? "hidden" : "auto",
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
